import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_ALL: ColumnViewModel = {
  columns: [
    'name',
    'diseaseUMLSCUI',
    'type',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'nct_id',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numChemicals',
    'numPublications',
    'numPublications_GDA',
    'numPublications_VDA',
    'numCTs',
    'firstRef',
    'lastRef',
    'prevalence',
    'disease_inheritance',
    'diseaseCode_DO',
    'diseaseCode_MSH',
    'diseaseCode_HPO',
    'diseaseCode_ICD10',
    'diseaseCode_ICD9CM',
    'diseaseCode_NCI',
    'diseaseCode_OMIM',
    'diseaseCode_ORDO',
    'diseaseCode_MONDO',
    'diseaseCode_EFO',
  ],
  defaultVisible: [
    'name',
    'type',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numChemicals',
    'numPublications_GDA',
    'numPublications_VDA',
    'numCTs',
    'firstRef',
    'lastRef',
  ],
};